import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Img, svgSprite } from '../../../../hybrid/wrappers';
import Display from '../../../../common/components/Display';
import UserContext from '../../../../common/utils/getContext';
import { getMemoizedData } from '../../../../common/utils/memo';
import css from './Login.module.scss';
import classnames from 'classnames';
import { generateGridStyles } from '../../components/helpers';
import { generateUniqueId } from '../../../../common/utils/utils';
import ModalInfoOffice from '../../../userModalInfoOffice/ModalInfoOffice';
import T from '../../../../common/components/T';

const LoginOffice = ({ getHandlers = () => {}, val, gridStyles, name, link, align }) => {
    const { stylers, existCl, existSt } = generateGridStyles(gridStyles, name);
    const { userToken, lang } = useContext(UserContext);

    const [sideBar, setSideBar] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const getUserData = async (event, val) => {
        event.preventDefault();
        event.stopPropagation();
        if (val?.not_user || val?.is_deleted) return;
        if (val?.links?.partner || val?.id) {
            setSideBar(true);
        }
        const data = val?.links?.partner
            ? await getMemoizedData(val?.links?.partner, userToken, lang)
            : val?.id && (await getMemoizedData(`/api/v1/user/partners/${val?.id}`, userToken, lang));
        if (!data) return;
        const sponsorData = data?.data?.sponsor_id
            ? await getMemoizedData(`/api/v1/user/partners/${data?.data?.sponsor_id}`, userToken, lang)
            : null;
        const rankData = await getMemoizedData(data.data.marketing_profile.links.rank_progress, userToken, lang);
        if (data && data?.data) {
            setUserInfo({
                ...data.data.profile,
                ...data.data,
                sponsor: sponsorData?.data,
                activity: data.data?.marketing_profile?.activity,
                rankData: rankData.data,
                rank: rankData?.data?.current_rank,
                package: data?.data?.marketing_profile?.package,
                new_partners_number: data?.data?.marketing_profile?.new_partners_number,
                active_partners_number: data?.data?.marketing_profile?.active_partners_number,
                children_number: data?.data?.children_count,
                partners_number: data?.data?.descendants_count
            });
        }
    };
    // const cursor = useMemo(() => (val?.not_user ? { cursor: 'default' } : { cursor: 'pointer' }), [val]);
    if (!val || (typeof val === 'object' && !val.username && !val.not_user)) {
        return <p>-</p>;
    }
    return (
        <>
            <div
                style={existSt('wrapper') || {}}
                className={classnames(
                    existCl('wrapper') ||
                        (align === 'left'
                            ? [css.flexRow, css.alignItemsCenter]
                            : align === 'right'
                            ? [css.flexRow, css.alignItemsEnd]
                            : [css.flexRow, css.alignItemsCenter])
                )}
            >
                {val?.image?.links?.preview ? (
                    <div className={classnames(css.loginImage, existCl('image'))}>
                        {val?.imageLeader ? (
                            <Img src='/src/img/widgets/login/LeaderFrame.svg' alt='Frame' className={css.loginFrame} />
                        ) : null}
                        <Img
                            className={classnames(css.loginImage, existCl('image'))}
                            src={val?.image?.links?.preview}
                            width={54}
                            height={54}
                            alt='User image'
                        />
                    </div>
                ) : !val.not_user ? (
                    <div className={classnames(css.loginImage, existCl('image'))}>
                        {val?.imageLeader ? (
                            <Img src='/src/img/widgets/login/LeaderFrame.svg' alt='Frame' className={css.loginFrame} />
                        ) : null}
                        {svgSprite('plug-user-image', { className: css.loginSvg })}
                    </div>
                ) : null}
                <div className={css.buyerNameWrapper}>
                    <p
                        key={generateUniqueId()}
                        style={stylers.fio}
                        className={classnames(
                            existCl('fio') || css.buyerName,
                            (!val?.not_user &&
                                !['full_name', 'first_name', 'last_name', 'patronymic']?.some((el) => !!val[el])) ||
                                (!val?.not_user && val?.username === val?.full_name) ||
                                val?.not_user
                                ? css.mb0
                                : ''
                        )}
                    >
                        {val.not_user ? (
                            val.not_user
                        ) : val.full_name ? (
                            val.full_name != val?.username ? (
                                val.full_name
                            ) : null
                        ) : (
                            <Display
                                type='fio'
                                data={{
                                    first_name: val.first_name,
                                    last_name: val.last_name,
                                    patronymic: val.patronymic
                                }}
                            />
                        )}
                    </p>
                    {!val.not_user ? (
                        <div
                            {...getHandlers(false)}
                            style={stylers.icoWrap1}
                            className={
                                existCl('icoWrap1') ||
                                classnames(
                                    css.userNameBlock,
                                    !link && !val?.id && !val?.links?.partner && css.userNameBlockDisabled,
                                    val.full_name || (val.first_name && val.last_name && val.patronymic)
                                        ? css.userNameBlockMb
                                        : ''
                                )
                            }
                            onClick={(event) => getUserData(event, val)}
                        >
                            {/* <span
                                style={stylers.icoWrap2}
                                className={
                                    existCl('icoWrap2')
                                        ? classnames(css.dFlex, css.alignItemsCenter, existCl('icoWrap2'))
                                        : classnames(css.marginRight8, css.dFlex, css.alignItemsCenter)
                                }
                            >
                                {svgSprite('user-circle-fill', {
                                    style: existSt('ico') || {
                                        fill: 'var(--blueColor)'
                                    },
                                    className: existCl('ico') || css.userNameBlockIcon
                                })}
                            </span> */}
                            <p style={{ whiteSpace: 'nowrap' }}>{`${val.username || val}`}</p>
                        </div>
                    ) : null}
                </div>
            </div>
            {val?.link_detail ? (
                <a
                    href={val?.link_detail}
                    style={{
                        textDecoration: 'underline',
                        marginTop: '10px',
                        cursor: 'pointer'
                    }}
                >
                    <T textName='reports_detail' defaultStr='Детализация' page='all' />
                </a>
            ) : val?.link_detail_modal?.func ? (
                <div
                    onClick={() => val.link_detail_modal.func()}
                    style={{ textDecoration: 'underline', color: 'var(--goldColor)', cursor: 'pointer' }}
                >
                    <T textName='reports_detail' defaultStr='Детализация' page='all' />
                </div>
            ) : null}
            {sideBar ? (
                <ModalInfoOffice
                    userData={userInfo}
                    setShowUser={setSideBar}
                    setUserData={setUserInfo}
                    closeHandler={(e) => {
                        e.stopPropagation();
                        setSideBar(false);
                        setUserInfo(null);
                    }}
                />
            ) : null}
        </>
    );
};
LoginOffice.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
};
export default LoginOffice;
